import { render, staticRenderFns } from "./gender-prop.vue?vue&type=template&id=2bc7ba1d&scoped=true"
import script from "./gender-prop.vue?vue&type=script&lang=js"
export * from "./gender-prop.vue?vue&type=script&lang=js"
import style0 from "./gender-prop.vue?vue&type=style&index=0&id=2bc7ba1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7ba1d",
  null
  
)

export default component.exports